import React, { useEffect, useState } from "react";
import Form, {
  ButtonItem,
  SimpleItem,
  GroupItem,
  Label,
  TabbedItem,
  TabPanelOptions,
  Tab,
  RequiredRule,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import notify from "devextreme/ui/notify";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { loadMessages, formatMessage, locale } from "devextreme/localization";
import dictionary from "../../../data/dictionary";
import useJSON from "../../../hook/useJSON";
import FileSelectPopup from "../../file/FileSelectPopup";
import { WEBSITE_URL } from "../../../utils/constants";

loadMessages(dictionary);

const tabsMock = [
  {
    id: 0,
    text: "vi-VN",
    icon: "globe",
    content: "Vietnamese",
  },
];

const ServiceFAQVM = (data, languages) => {
  const returnData = useJSON(data, languages);

  return returnData;
};

const ServiceFAQMV = (data, languages) => {
  const questionObj = {};
  const answerObj = {};
  languages.forEach((language) => {
    questionObj[[language.languageId]] =
      data[`question-${language.languageId}`];
    answerObj[[language.languageId]] = data[`answer-${language.languageId}`];
  });

  return JSON.stringify({
    question: JSON.stringify(questionObj),
    answer: JSON.stringify(answerObj),
    image: data.image,
    alt: data.alt,
    order: data.order,
    isActive: data.isActive,
    concurrencyStamp: data.concurrencyStamp,
  });
};

const WebsiteServiceFAQDetail = ({
  accessToken,
  currentLanguage,
  currentWebsite,
  websiteLanguages,
  serviceId,
  id,
  hidePopup,
}) => {
  locale(currentLanguage.substring(0, 2));
  const history = useHistory();
  const [serviceFAQ, setServiceFAQ] = useState({ isActive: true });
  const [tabs, setTabs] = useState(tabsMock);

  useEffect(() => {
    const _tabs = websiteLanguages.map((item, index) => ({
      id: index,
      languageId: item.languageId,
      text: item.name,
      icon: "globe",
      content: "User tab content",
    }));
    setTabs(_tabs);
  }, [websiteLanguages]);

  useEffect(() => {
    if (!currentWebsite || !id) {
      return;
    }
    fetch(`${WEBSITE_URL}Services/faq/${currentWebsite}/${serviceId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Access-Control-Allow-Origin": "*",
      },
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            setServiceFAQ(ServiceFAQVM(json.data, websiteLanguages));
            return;
          }
          throw json.Message;
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  }, [currentWebsite, id, serviceId, history, websiteLanguages, accessToken]);

  const updateService = () => {
    return fetch(
      `${WEBSITE_URL}Services/faq/${currentWebsite}/${serviceId}/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Accept-Language": currentLanguage,
        },
        body: ServiceFAQMV(serviceFAQ, websiteLanguages),
      }
    ).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            hidePopup();
            notify(
              {
                message: json.message,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "success",
              3000
            );
            return;
          }
          throw json.Message;
        })
        .catch((err) => {
          if (result.status === 401) {
            history.push("/login");
          } else {
            notify(
              {
                message: err,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "error",
              3000
            );
          }
        })
    );
  };

  const addService = () => {
    return fetch(`${WEBSITE_URL}Services/faq/${currentWebsite}/${serviceId}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": currentLanguage,
      },
      body: ServiceFAQMV(serviceFAQ, websiteLanguages),
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            hidePopup();
            notify(
              {
                message: json.message,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "success",
              3000
            );
            return;
          }
          throw json.message;
        })
        .catch((err) => {
          if (result.status === 401) {
            history.push("/login");
          } else {
            notify(
              {
                message: err,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "error",
              3000
            );
          }
        })
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      updateService();
    } else {
      addService();
    }
  };

  const saveButtonOptions = {
    text: formatMessage("save"),
    icon: "save",
    type: "default",
    stylingMode: "contained",
    useSubmitBehavior: true,
  };

  const updateImage = (e) => {
    setServiceFAQ((prevState) => ({ ...prevState, image: e }));
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Item
          location="center"
          text={`${formatMessage("info")} ${formatMessage(
            "of"
          )} ${formatMessage("faq")}`}
        />
      </Toolbar>
      <form action="your-action-faq" onSubmit={handleSubmit}>
        <Form
          formData={serviceFAQ}
          readOnly={false}
          colCount={1}
          showColonAfterLabel={true}
          showValidationSummary={true}
          validationGroup="customerDataFAQ"
        >
          <GroupItem caption="Đa ngôn ngữ">
            <TabbedItem>
              <TabPanelOptions deferRendering={false} />
              {tabs.map((item) => {
                return (
                  <Tab key={item.id} title={item.text} icon={item.icon}>
                    <SimpleItem
                      dataField={`question-${item.languageId}`}
                      editorType="dxTextBox"
                    >
                      <Label text={formatMessage("question")} />
                      <RequiredRule
                        message={`${formatMessage("question")} ${formatMessage(
                          item.languageId
                        )} ${formatMessage("errMesRequire")}`}
                      />
                    </SimpleItem>
                    <SimpleItem
                      dataField={`answer-${item.languageId}`}
                      editorType="dxTextArea"
                    >
                      <Label text={formatMessage("answer")} />
                      <RequiredRule
                        message={`${formatMessage("answer")} ${formatMessage(
                          item.languageId
                        )} ${formatMessage("errMesRequire")}`}
                      />
                    </SimpleItem>
                  </Tab>
                );
              })}
            </TabbedItem>
          </GroupItem>

          <GroupItem caption="Nội dung khác" colCount={2}>
            <SimpleItem>
              <Label text={formatMessage("image")} />
              <FileSelectPopup
                value={serviceFAQ.image}
                imgHeight={100}
                onValueChanged={updateImage}
              />
              <RequiredRule />
            </SimpleItem>
            <GroupItem>
              <SimpleItem dataField={"alt"} editorType="dxTextBox" colSpan={2}>
                <Label text={formatMessage("alt")} />
              </SimpleItem>
              <SimpleItem dataField="url" editorType="dxTextBox">
                <Label text={formatMessage("url")} />
              </SimpleItem>
              <SimpleItem dataField="order" editorType="dxNumberBox">
                <Label text={formatMessage("order")} />
              </SimpleItem>
              <SimpleItem dataField="isActive" editorType="dxCheckBox">
                <Label text={formatMessage("isActive")} />
              </SimpleItem>
            </GroupItem>
          </GroupItem>

          <GroupItem horizontalAlignment="center">
            <ButtonItem
              horizontalAlignment="center"
              validationGroup="customerDataFAQ"
              buttonOptions={saveButtonOptions}
            />
          </GroupItem>
        </Form>
      </form>
    </React.Fragment>
  );
};

WebsiteServiceFAQDetail.propTypes = {
  accessToken: PropTypes.string,
  languages: PropTypes.array,
  currentLanguage: PropTypes.string,
  websiteId: PropTypes.string,
  websiteLanguages: PropTypes.array,
  currentWebsite: PropTypes.string,
  serviceId: PropTypes.string,
  id: PropTypes.string,
  hidePopup: PropTypes.func,
};

export default WebsiteServiceFAQDetail;
